//!function(){"use strict";class t extends HTMLElement{constructor(){super(),this.section=this.closest("product-info"),this.form=this.section.querySelector("[data-product-form]"),this.formWrapper=theme.settings.productPageSticky&&this.section.querySelector("[data-form-wrapper]")||this.form,this.handleProductAddError=this.handleProductAddError.bind(this),this.boundToggleCartBarOnScroll=this.toggleCartBarOnScroll.bind(this),this.boundSetCartBarHeight=this.setCartBarHeight.bind(this)}connectedCallback(){this.setCartBarHeight(),this.addEventListener("click",this.handleClick.bind(this)),document.addEventListener("theme:scroll",this.boundToggleCartBarOnScroll),document.addEventListener("theme:resize",this.boundSetCartBarHeight),document.addEventListener("theme:product:add-error",this.handleProductAddError)}handleClick(t){const e=t.target.closest("[data-cart-bar-add-to-cart]");if(e)return t.preventDefault(),e.classList.add("is-loading"),e.setAttribute("disabled","disabled"),void this.form.querySelector("[data-add-to-cart]").dispatchEvent(new Event("click",{bubbles:!0}));t.target.closest("[data-cart-bar-scroll]")&&(t.preventDefault(),this.scrollToTop())}handleProductAddError(){this.querySelector("[data-cart-bar-add-to-cart]")&&this.scrollToTop()}scrollToTop(){const t=this.section.querySelector("variant-selects"),e=(window.theme.isMobile()?t||this.form:this.section).getBoundingClientRect().top;window.theme.scrollTo(window.theme.isMobile()?e-10:e)}toggleCartBarOnScroll(){const t=window.scrollY;if(this.formWrapper){const e=t>this.formWrapper.offsetTop+this.formWrapper.offsetHeight;this.classList.toggle("is-visible",e)}}setCartBarHeight(){const t=this.offsetHeight;document.documentElement.style.setProperty("--cart-bar-height",`${t}px`)}disconnectedCallback(){document.removeEventListener("theme:product:add-error",this.handleProductAddError),document.removeEventListener("theme:scroll",this.boundToggleCartBarOnScroll),document.removeEventListener("theme:resize",this.boundSetCartBarHeight)}}customElements.get("cart-bar")||customElements.define("cart-bar",t)}();
(function () {
  'use strict';

  class CartBar extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('product-info');
      this.form = this.section?.querySelector('[data-product-form]');
      this.formWrapper =
        theme.settings.productPageSticky && this.section?.querySelector('[data-form-wrapper]') || this.form;
      this.handleProductAddError = this.handleProductAddError.bind(this);
      this.boundToggleCartBarOnScroll = this.toggleCartBarOnScroll.bind(this);
      this.boundSetCartBarHeight = this.setCartBarHeight.bind(this);
      this.boundVariantChange = this.onVariantChange.bind(this);
    }

    connectedCallback() {
      this.setCartBarHeight();
      this.addEventListener('click', this.handleClick.bind(this));

      // Cache product JSON once (variants) for variant syncing
      this.productJson = this.getProductJson();

      // Delegate change events so it still works after innerHTML updates
      this.addEventListener('change', (event) => {
        const select = event.target.closest('[data-cart-bar-variant-select]');
        if (!select || !this.contains(select)) return;
        this.handleVariantSelectChange(select);
      });

      document.addEventListener('theme:scroll', this.boundToggleCartBarOnScroll);
      document.addEventListener('theme:resize', this.boundSetCartBarHeight);
      document.addEventListener('theme:product:add-error', this.handleProductAddError);

      if (typeof subscribe === 'function' && theme && theme.PUB_SUB_EVENTS) {
        this.variantChangeUnsub = subscribe(theme.PUB_SUB_EVENTS.variantChange, this.boundVariantChange);
      }
    }

    getProductJson() {
      const script = this.querySelector('[data-cart-bar-product]');
      if (!script || !script.textContent) return null;
      try {
        return JSON.parse(script.textContent.trim());
      } catch (e) {
        return null;
      }
    }

    handleClick(e) {
      const addBtn = e.target.closest('[data-cart-bar-add-to-cart]');
      if (addBtn) {
        e.preventDefault();
        addBtn.classList.add('is-loading');
        addBtn.setAttribute('disabled', 'disabled');
        // Prefer submitting the main product form so all theme logic runs
        const mainForm = this.section?.querySelector('form[data-product-form]');
        if (mainForm) {
          if (typeof mainForm.requestSubmit === 'function') {
            // Modern browsers: submit as if user clicked the main button
            const mainButton = mainForm.querySelector('[data-add-to-cart]');
            mainForm.requestSubmit(mainButton || undefined);
          } else {
            // Fallback: dispatch a submit event
            mainForm.dispatchEvent(
              new Event('submit', {
                bubbles: true,
                cancelable: true,
              }),
            );
          }
        } else {
          // Fallback: re-enable button if no main form is found
          addBtn.classList.remove('is-loading');
          addBtn.removeAttribute('disabled');
        }
        return;
      }

      const scrollBtn = e.target.closest('[data-cart-bar-scroll]');
      if (scrollBtn) {
        e.preventDefault();
        this.scrollToTop();
      }
    }

    handleProductAddError() {
      if (this.querySelector('[data-cart-bar-add-to-cart]')) {
        this.scrollToTop();
      }
    }

    scrollToTop() {
      const variantSelects = this.section?.querySelector('variant-selects');
      const target = window.theme?.isMobile() ? (variantSelects || this.form) : this.section;
      if (target) {
        const top = target.getBoundingClientRect().top;
        window.theme?.scrollTo?.(window.theme.isMobile() ? top - 10 : top);
      }
    }

    toggleCartBarOnScroll() {
      const scrollY = window.scrollY || window.pageYOffset;
      if (this.formWrapper) {
        const formBottom = this.formWrapper.offsetTop + this.formWrapper.offsetHeight;
        this.classList.toggle('is-visible', scrollY > formBottom);
      }
    }

    setCartBarHeight() {
      const h = this.offsetHeight;
      document.documentElement.style.setProperty('--cart-bar-height', h + 'px');
    }

    /**
     * When user changes variant in cart-bar select: sync main form variant-selects
     * so product-info receives optionValueSelectionChange and fetches updated section.
     */
    handleVariantSelectChange(select) {
      const variantId = select.value;
      if (!variantId || !this.productJson || !this.productJson.variants) return;
      // Reuse product-info guard to avoid gallery autoscroll when change originates from sticky bar.
      window.__fromVariantSection = true;

      const variant = this.productJson.variants.find(function (v) {
        return String(v.id) === String(variantId);
      });
      if (!variant) return;

      const variantSelects = this.section?.querySelector('variant-selects');
      if (!variantSelects) return;

      const options = [variant.option1, variant.option2, variant.option3].filter(Boolean);

      options.forEach(function (optionValue, index) {
        const position = index + 1;
        const wrapper = variantSelects.querySelector('[data-option-position="' + position + '"]');
        if (!wrapper) return;

        const radios = wrapper.querySelectorAll('input[type="radio"]');
        for (let i = 0; i < radios.length; i++) {
          if (radios[i].value === optionValue && !radios[i].checked) {
            radios[i].checked = true;
            radios[i].dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
        }

        const popoutOptions = wrapper.querySelectorAll('[data-popout-option][data-value]');
        for (let i = 0; i < popoutOptions.length; i++) {
          if (popoutOptions[i].getAttribute('data-value') === optionValue) {
            popoutOptions[i].click();
            return;
          }
        }

        const nativeSelect = wrapper.querySelector('select');
        if (nativeSelect) {
          const opts = nativeSelect.querySelectorAll('option');
          for (let i = 0; i < opts.length; i++) {
            if (opts[i].value === optionValue || opts[i].text.trim() === optionValue) {
              nativeSelect.selectedIndex = i;
              nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
              break;
            }
          }
        }
      });
    }

    onVariantChange(payload) {
      if (!payload?.data?.sectionId || !payload?.data?.variant) return;
      const sectionId = this.getAttribute('data-section-id') || this.section?.dataset?.section;
      if (String(payload.data.sectionId) !== String(sectionId)) return;

      const variantId = payload.data.variant.id;
      const select = this.querySelector('[data-cart-bar-variant-select]');
      if (select && select.value !== String(variantId)) {
        select.value = String(variantId);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('theme:product:add-error', this.handleProductAddError);
      document.removeEventListener('theme:scroll', this.boundToggleCartBarOnScroll);
      document.removeEventListener('theme:resize', this.boundSetCartBarHeight);
      if (this.variantChangeUnsub) {
        this.variantChangeUnsub();
      }
    }
  }

  if (!customElements.get('cart-bar')) {
    customElements.define('cart-bar', CartBar);
  }
})();


document.addEventListener("DOMContentLoaded", function() {
// Select the target desktop and mobile elements
var linkElementsDesktop = document.querySelectorAll(".product-linklist:not(.mobile-layout) a");
var linkElementsMobile = document.querySelectorAll(".product-linklist.mobile-layout a");

const offset = 130; // Adjust this value as needed

// Function to update active link based on scroll position
function updateActiveLink(linkElements) {
    let currentSection = null;

    linkElements.forEach(function(link) {
        const targetSelector = link.getAttribute("data-scroll-to");
        const targetSection = document.querySelector(targetSelector);

        if (targetSection) {
            const sectionTop = targetSection.offsetTop - offset;
            const sectionBottom = sectionTop + targetSection.offsetHeight;

            if (window.scrollY >= sectionTop && window.scrollY < sectionBottom) {
                currentSection = link;
            }
        }
    });

    // Remove 'active' class from all links
    linkElements.forEach(function(link) {
        link.classList.remove("active");
    });

    // Add 'active' class to the current link
    if (currentSection) {
        currentSection.classList.add("active");

        // Scroll the mobile navigation bar to bring the active link into view
        if (currentSection.closest('.mobile-layout')) {
            currentSection.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center'
            });
        }
    }
}

// Function to handle link click and smooth scroll
function handleLinkClick(event) {
    event.preventDefault();

    const targetSelector = this.getAttribute("data-scroll-to");
    const targetSection = document.querySelector(targetSelector);

    if (targetSection) {
        window.scrollTo({
            top: targetSection.offsetTop - offset,
            behavior: "smooth"
        });
    }
}

// Add scroll event listener to update active link on scroll
window.addEventListener("scroll", function() {
    updateActiveLink(linkElementsDesktop);
    updateActiveLink(linkElementsMobile);
});

// Add click event listeners to links
linkElementsDesktop.forEach(function(link) {
    link.addEventListener("click", handleLinkClick);
});

linkElementsMobile.forEach(function(link) {
    link.addEventListener("click", handleLinkClick);
});

// Add a scroll event listener to the window for adding 'scrolled' class on mobile
const mobileLinkList = document.querySelector('.product-linklist.mobile-layout');
window.addEventListener('scroll', function() {
    if (!mobileLinkList) return;
    if (window.scrollY > 100) {
        mobileLinkList.classList.add('scrolled');
    } else {
        mobileLinkList.classList.remove('scrolled');
    }
});



    var readMore = document.getElementById('read-more');
    var readLess = document.getElementById('read-less');
if(readMore){
    readMore.addEventListener('click', function() {
      document.getElementById('truncated-description').style.display = 'none';
      document.getElementById('full-description').style.display = 'block';
      readMore.style.display = 'none';
      readLess.style.display = 'block';
    });

    readLess.addEventListener('click', function() {
      document.getElementById('truncated-description').style.display = 'block';
      document.getElementById('full-description').style.display = 'none';
      readMore.style.display = 'block';
      readLess.style.display = 'none';
    });
}
  });